module.exports = __webpack_public_path__ + "img/gradyelblue.63dcfc4a.png";